<div class="ui-dialog-container invoice-notes-dialog" style="width: 100%">
  <div class="ui-dialog-toolbar">
    <button mat-icon-button mat-dialog-close color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div>
    <h1>{{ "forms.comment" | translate }}</h1>
    <mat-card *ngIf="notes?.length" style="width: 90%">
      <h3>{{ "btn.history" | translate }}</h3>
      <table>
        <thead>
          <th>{{ "table.author" | translate }}</th>
          <th>
            {{ "table.comment" | translate }}
          </th>
          <th>{{ "table.date" | translate }}</th>
        </thead>
        <tbody>
          <ng-container *ngFor="let note of notes">
            <tr>
              <td>{{ note?.author?.display ?? ("page.login.title" | translate) }}</td>
              <td>
                {{ BILLABLE_REASON_KEYS.includes(note.text) ? ("page.invoices.notes." + note.text | translate) : note.text }}
              </td>
              <td>{{ note?.time | safeDate }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </mat-card>
    <mat-card
      class="mt-1"
      *ngIf="('dashboard/newChargeItemComment' | isAuthorized : 'PUT' | async) === true"
      style="display: inline-block; width: 90%"
    >
      <textarea cdkTextareaAutosize matInput placeholder="{{ 'forms.addComment' | translate }}" [(ngModel)]="comment"></textarea>
      <button mat-raised-button color="primary" style="float: right" *ngIf="comment?.length" (click)="save()">
        {{ "common.save" | translate }}
      </button>
    </mat-card>
  </div>
</div>
